export function apiHeaders(task) {
  return {
    headers: {
      task,
      "Content-Type": "application/json",
      Accept: "application/json",
      token: "amazewebtokentedf8i70ghsghrst",
    },
  };
}
